const getRuntimeConfigValues = (publicRuntimeConfig) => {
  const {
    APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID,
    APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE,
    APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES
  } = publicRuntimeConfig?.grandvision?.featureConfigs ?? {};
  const virtualAppointmentTypeId = typeof APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID === "string" ? APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID : void 0;
  const virtualStoreCode = typeof APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE === "string" ? APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE : void 0;
  const alternativeUrlStores = typeof APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES === "string" ? APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES : void 0;
  return { virtualStoreCode, virtualAppointmentTypeId, alternativeUrlStores };
};
export {
  getRuntimeConfigValues
};
//# sourceMappingURL=get-runtime-config-values.js.map
